import difference from "lodash/difference"
import eventToItem from "./eventToItem"

// todo: id, rowIndex, isLast
const transformResourceToGroup = resource => ({
  uuid: resource.uuid,
  title: resource.name,
  label: resource.label,
  fields: resource.fields,
  typeId: resource.resourceTypeId,
  typeName: resource.resourceTypeName,
  externalLink: resource.externalLink,
  isDeleted: Boolean(resource.deleteDate),
})

// Проверка пересечения отрезков
// Касание границами не считается пересечением
const intersects = (x1, x2, y1, y2) => x2 > y1 && y2 > x1

export const isInRangeOf = (event, evtToCheck) => {
  const start1 = event.startDateTime
  const start2 = evtToCheck.startDateTime
  const end1 = event.endDateTime
  const end2 = evtToCheck.endDateTime

  return intersects(start1, end1, start2, end2)
}

const isCollide = (item1, item2) => {
  const start1 = item1.start_time.valueOf()
  const start2 = item2.start_time.valueOf()
  const end1 = item1.end_time.valueOf()
  const end2 = item2.end_time.valueOf()

  return intersects(start1, end1, start2, end2)
}

// Срезает слой непересекающихся событий
const sliceLayer = items =>
  items.reduce(
    (itemsForLayer, item) =>
      !itemsForLayer.some(layerItem => isCollide(item, layerItem))
        ? [...itemsForLayer, item]
        : itemsForLayer,
    [],
  )

// Разбивает итемы на слои
const splitLayers = items => {
  const splitLayersIter = (items, layer, result) => {
    const itemsForLayer = sliceLayer(items)

    return itemsForLayer.length
      ? splitLayersIter(difference(items, itemsForLayer), layer + 1, [
          ...result,
          itemsForLayer,
        ])
      : result
  }
  return splitLayersIter(items, 0, [])
}

const getLayerMap = items =>
  splitLayers(items).reduce(
    (map, layerItems, index) => ({
      ...map,
      ...layerItems.reduce((map, item) => ({ ...map, [item.id]: index }), {}),
    }),
    {},
  )

const applyLayerMapForItems = (layerMap, items) =>
  items.map(item => ({
    ...item,
    layer: layerMap[item.id],
  }))

const applyLayerMapForGroup = (layerMap, group) => ({
  ...group,
  layers: Math.max(0, ...Object.values(layerMap)) + 1,
})

export const prepareCalendarData = ({ inPlan, calendarData }) => {
  const { items, groups } = calendarData.reduce(
    ({ items, groups }, record, index, array) => {
      const recordResource = record.resource
      const resourceUuid = recordResource.uuid

      const recordEvents = record.items

      const recordItems = recordEvents.map(event => ({
        ...eventToItem(event, recordResource, inPlan),
        group: resourceUuid,
      }))
      const layerMap = getLayerMap(recordItems)
      const layeredRecordItems = applyLayerMapForItems(layerMap, recordItems)
      const recordGroup = applyLayerMapForGroup(
        layerMap,
        transformResourceToGroup(recordResource),
      )

      return {
        items: [...items, ...layeredRecordItems],
        groups: [
          ...groups,
          {
            ...recordGroup,
            id: resourceUuid,
            rowIndex: index,
            ...(index === array.length - 1 ? { isLast: true } : null),
          },
        ],
      }
    },
    { items: [], groups: [] },
  )
  return { items, groups }
}
